import { render, staticRenderFns } from "./creatAttr.vue?vue&type=template&id=884b0e2e&scoped=true"
import script from "./creatAttr.vue?vue&type=script&lang=js"
export * from "./creatAttr.vue?vue&type=script&lang=js"
import style0 from "./creatAttr.vue?vue&type=style&index=0&id=884b0e2e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884b0e2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('884b0e2e')) {
      api.createRecord('884b0e2e', component.options)
    } else {
      api.reload('884b0e2e', component.options)
    }
    module.hot.accept("./creatAttr.vue?vue&type=template&id=884b0e2e&scoped=true", function () {
      api.rerender('884b0e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/components/creatAttr.vue"
export default component.exports